import React from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { ContentBlockLoading } from 'components/ContentBlock'
import { Form, Text, Select, Checkbox, Number } from 'components/forms'
import Divider from 'components/Divider'
import { useQuery } from 'components/graphql'
import updateAppConfig from './gql/updateAppConfig'
import { loadAppConstants } from 'gql/query'
import { useTranslation } from 'react-i18next'
import styles from 'style/app.module.scss'

export const languageOptions = [
	{ label: 'German (Deutsch)', value: 'German' },
	{ label: 'English', value: 'English' },
	{ label: 'French (Français)', value: 'French' },
	{ label: 'Italian (Italiano)', value: 'Italian' },
	{ label: 'Polish (Polskie)', value: 'Polish' },
	{ label: 'Portuguese (Português)', value: 'Portuguese' },
	{ label: 'Russian (Русский)', value: 'Russian' }
]

const GeneralSettingsHandler = ({ sectionData: { itemQuery }, handleMutation, appData }) => {
	const [t, i18n] = useTranslation()
	const { data, loading, hasData } = useQuery(itemQuery)
	const handleUpdate = fields => {
		handleMutation({
			mutation: updateAppConfig,
			variables: { fields }
		})
	}
	const { __typename, ...fields } = hasData ? data.getAppConfig : {}
	return(
		<Form
			key={loading}
			smartSubmit
			onSubmit={handleUpdate}
			initialValues={fields}
			className='flex-col-container'
		>
			<ContentBlockLoading isLoading={!hasData} label={t('options_section.strings.business')} className={styles.itemView}>
				<Row>
					<Col xs>
						<Text field='name' label={t('options_section.fields.company_name')} placeholder='Firmenname eintragen'/>
						<Text field='street' label={t('options_section.fields.street')} placeholder='Strasse eintragen'/>
						<Text field='postCode' label={t('options_section.fields.postcode')} inline style={{ width: 100 }}/>
						<Text field='city' inline style={{ width: 180 }}/>
						<Checkbox field='isShopFieldActive' label={t('options_section.fields.shop_field_active')}/>
					</Col>
					<Col xs>
						<Select
							field='countryId'
							label={t('options_section.fields.company_profile')}
							remoteOptions={{
								query: loadAppConstants,
								variables: { type: 19, language: i18n.language }
							}}
						/>
						{/*<Select field='Landereinstellung' label='Landereinstellung'/>*/}
						<Select field='language' label={t('options_section.fields.language')} options={languageOptions}/>
					</Col>
				</Row>
				{appData?.cashRegisterGlobal?.isRevolutPaymentActive !== null && <>
					<Divider/>
					<Row>
						<Col xs>
							<Number precision={2} field='cashRegisterGlobal.revolutPaymentDiscount' label={t('options_section.fields.revolut_payment_discount')}/>
							<Checkbox field='cashRegisterGlobal.isRevolutPaymentActive' label={t('options_section.fields.is_revolut_payment_active')}/>
						</Col>
					</Row>
				</>}
			</ContentBlockLoading>
		</Form>
	)
}

export default GeneralSettingsHandler
